import {
  ActionCardModel,
  enrichActionCardWithProps,
  getAvailableTags,
  getFlowStatus,
} from '@playbooks/action-cards-utils'
import { ActionCard } from '@playbooks/core/src/interfaces/ActionCard'

import { Set } from '..'
import getElementsWithCode from '../../utils/getElementsWithCode'

export type SetActionCards = (data: ActionCard) => void

export default function actionSetActionCards(set: Set): SetActionCards {
  return (data: ActionCard) => {
    const { data: clonedData, flowData, availableTags, elementsWithCode } = processActionCardsData(data)

    set(state => ({
      ...state,
      data: clonedData,
      flowData,
      availableTags,
      elementsWithCode,
    }))
  }
}

export function processActionCardsData(data: ActionCard) {
  const clonedData = JSON.parse(JSON.stringify(data)) as ActionCard

  enrichActionCardWithProps(clonedData)

  const actionCardsModel = new ActionCardModel(clonedData || null!)

  const flowData = getFlowStatus(clonedData)
  const availableTags = getAvailableTags(clonedData.sections)
  const elementsWithCode = getElementsWithCode(actionCardsModel)

  return {
    data: clonedData,
    flowData,
    availableTags,
    elementsWithCode,
  }
}
